(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('ApplicationController', ApplicationController);

	ApplicationController.$inject = ['$log', 'lodash', '$analytics', '$window'];

	function ApplicationController($log, lodash, $analytics, $window) {

		/* jshint validthis: true */
		var self = this;

		// Make methods public
		self.answerQuestion = answerQuestion;
		self.submit = submit;

		// states
		self.currentQuestionIndex = 0;
		self.showJoin = false;
		self.showDone = false;
		self.showEmail = false;

		// data
		self.results = [];
		self.email = null;
		self.failedQuestionKeys = [];
		self.applicationComplete = false;
		self.applicationVersion = 1;
		// available plans to populate radio group
		self.questions = [
			{
				key: "Q1",
				question: "Do you plan to take photos of wine labels for research purposes or data entry?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "No",
				error: "We do not have a photo feature, and is not designed to help you decide which wine you want to buy at the store. We leave the wine purchasing and selling entirely up to you. We're just here to help you manage it all. So, if photo taking is something you are looking for, Personal Wine Curator is simply not for you."
			},
			{
				key: "Q2",
				question: "Would you like to record wine tasting ratings and notes on a regular basis?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "No"
			},
			{
				key: "Q3",
				question: "Would you like to print barcodes, bottle tags and/or labels on a regular basis?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "Yes"
			},
			{
				key: "Q4",
				question: "Are you interested in adding custom fields?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "Yes"
			},
			{
				key: "Q5",
				question: "Are you interested in managing multiple cellars?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "Yes"
			},
			{
				key: "Q6",
				question: "Are you interested in generating multiple types of custom reports?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "Yes"
			},
			{
				key: "Q7",
				question: "Would you like to increase your knowledge of food and wine pairing?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "Yes"
			},
			{
				key: "Q8",
				question: "Do you want to monitor the age and optimal drink dates of your wines with more accuracy?",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "Yes"
			},
			{
				key: "Q9",
				question: "Do you require phone support? (Versus online chat and email support)",
				options: [
					"Yes",
					"No",
					"Maybe"
				],
				correct: "No",
				error: "We don't explicitly offer phone support. Our customer service and membership suggestion box is strictly digital. So, if phone support is something you are looking for, Personal Wine Curator is probably not for you."
			},
			{
				key: "Q10",
				question: "What level of experience in wine collecting do you have?",
				options: [
					"Beginner",
					"Intermediate",
					"Expert"
				],
				correct: "Expert"
			},
		];


		// this has been copied from join.js. @TODO Consolidate (into a PlansRepository?)
		// available plans to populate radio group
		self.availablePlans = [
			{
				label: "$10/mo",
				price: "10",
				plan_description: "Up to 500 unique wines. For the connoisseur.",
				plan_name: "Third Growth",
				plan_code: "third_growth"
			},
			{
				label: "$20/mo",
				price: "20",
				plan_description: "Up to 1,000 unique wines. For the collector.",
				plan_name: "Second Growth",
				plan_code: "second_growth"
			},
			{
				label: "$40/mo",
				price: "40",
				plan_description: "Up to 2,000 unique wines. For the investor.",
				plan_name: "First Growth",
				plan_code: "first_growth"
			}
		];

		initialize();

		/** begin methods */
		function initialize() {
			$analytics.eventTrack('Viewed Application Page');

			// load intercom
			$window.Intercom("boot", {
				app_id: "c5mj6vtf"
			});
		}

		function  answerQuestion(question, answer) {
			$analytics.eventTrack('Answered Application Question', {
				applicationVersion: self.applicationVersion,
				questionKey: question.key
			});

			// put answer in question and add to users results.
			question.answer = answer;
			self.results.push(question);

			if (question.correct !== answer) {
				if (! lodash.isEmpty(question.error)) {
					// keep track of failed question keys
					self.failedQuestionKeys.push(question.key);
				}
			}

			if ((self.currentQuestionIndex + 1) === self.questions.length) {
				// Done with questions, Last Step
				self.showEmail = true;
				// mark application completed
				self.applicationComplete = true;
				sendResultsToIntercom();
				return;
			}

			// goto next question / tab
			showNextQuestion();
		}

		/**
		 * show next question
		 */
		function showNextQuestion() {
			// unmark current question as active
			delete self.questions[self.currentQuestionIndex].active;
			// increment question index then mark next question as active
			self.questions[++self.currentQuestionIndex].active = true;
		}

		function submit() {
			convertIntercomLeadToUser();
			
			// hide email form
			self.showEmail = false;

			// show join or done
			if (lodash.isEmpty(self.failedQuestionKeys)) {
				self.showJoin = true;
			} else {
				self.showDone = true;
			}
		}

		/**
		 * convert Intercom Lead to User so we can auto-message email them
		 */
		function convertIntercomLeadToUser() {
			$analytics.eventTrack('Application Email Submitted', {
				email: self.email,
			});
			var metadata = {
				user_id: self.email,
				email: self.email,
				actual_type: 'lead',
				created_at: $window.moment().unix(),
			};
			$window.Intercom('update', metadata);
		}

		/**
		 * Send to results to intercom. Update Intercom user type.
		 *
		 * mark user pass / fail
		 * mark user's incorrect questions so we can talk about it in the Intercom automessage email
		 */
		function sendResultsToIntercom() {
			// submit Intercom application submission event
			var status = getApplicationStatus();
			var failedQuestionsKeysString = self.failedQuestionKeys.join();
			var eventMetadata = {
				applicationVersion: self.applicationVersion,
				status: status,
			};
			if (! lodash.isEmpty(failedQuestionsKeysString)) {
				eventMetadata.application_failures = failedQuestionsKeysString;
			}
			$window.Intercom('trackEvent', 'application-submission', eventMetadata);

			// Convert Intercom Lead to User
			var userMetadata = {
				actual_type: 'lead',
				application_status: status,
				application_version: self.applicationVersion,
				application_submitted_at: $window.moment().unix(),
			};

			// add failed questions
			if (! lodash.isEmpty(failedQuestionsKeysString)) {
				userMetadata.application_failures = failedQuestionsKeysString;
			}
			$window.Intercom('update', userMetadata);
		}

		/**
		 * returns Pass or Incomplete or CSV of failed question keys. Eg. V1Q1,V1Q9
		 */
		function getApplicationStatus() {
			if (self.applicationComplete === false) {
				return 'Incomplete';
			}
			if (lodash.isEmpty(self.failedQuestionKeys)) {
				return 'Pass';
			} else {
				return 'Fail';
			}
		}

	}

})();
